import './Theme/plugins/fancybox/jquery.fancybox.css';
import './Theme/css/css.css';
import './Theme/css/font-awesome-4.7.0/css/font-awesome.min.css';
import './Theme/css/animate.css';
import React, { useEffect } from 'react';
import 'slick-carousel/slick/slick.css';
import Header from './Header';
import Menu from './CommonMenu';
// import 'slick-carousel/slick/slick-theme.css'; 
import $ from 'jquery';
window.jQuery = $;
require('textillate');
require('letteringjs');
require('slick-carousel');


function ContactPage() {
  useEffect(() => {
    $('.tlt').textillate({
      loop: true,
      minDisplayTime: 20000,
      in: {
        effect: 'fadeIn',
        delayScale: 3,
        shuffle: false,
      },
      out: {
        effect: 'fadeOut',
        delayScale: 1.5,
        delay: 100,
        sync: false,
        shuffle: false,
        reverse: false,
      }
    });

    $("#sky-bg").fadeIn(2e3);

    $(".slideHomeFade").slick({
      arrows: !1,
      lazyLoad: "ondemand",
      dots: !1,
      infinite: !0,
      speed: 2e3,
      fade: !0,
      slide: "div",
      autoplay: !0,
      autoplaySpeed: 2e3,
      cssEase: "linear"
    });

    $(".slideKinhSachUpdate").slick({
      infinite: !0,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: !0,
      speed: 3e3,
      dots: !1,
      autoplaySpeed: 5e3,

      // arrows: !1,
    });

    return () => {
      // Destroy Slick carousel to avoid memory leaks
      $('.slideHomeFade').slick('unslick');
      $('.slideKinhSachUpdate').slick('unslick');
    };

  }, []);
  return (
    <div>
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <meta httpEquiv="Content-Language" content="vi" />
      <title>Pháp Ấn Sơn | Linh Quy Pháp Ấn</title>
      <link rel="shortcut icon" href="/Upload/images/tab/logochuan.jpg" type="image/png" />
      <meta name="keywords" content="linh quy pháp ấn; linh quy phap an; Nikaya;  linhquyphapan; linhquy" />
      <meta name="description" content=" Pháp Ấn Sơn" />

      {/* <link href='https://fonts.googleapis.com/css?family=Roboto+Condensed|Open+Sans:400,700,400italic' rel='stylesheet' type='text/css'>
          <link href="/Theme/plugins/fancybox/jquery.fancybox.css" rel="stylesheet" />
          <link href="/Theme/css/css.css" rel="stylesheet"/>
          <link rel="stylesheet" href="/Theme/css/font-awesome-4.7.0/css/font-awesome.min.css">
          <link href="/Theme/css/animate.css" rel="stylesheet" />
          
          <script src="/Theme/js/jquery-1.11.2.min.js"></script> */}
      <div className="fly-text">
        <ul>
          <li className="tlt">Nguyện thành tựu</li>
          <li className="tlt">Lòng tin bất động</li>
          <li className="tlt">Nơi Đức Phật, Chánh Pháp</li>
          <li className="tlt">Chúng Tăng và Thánh Giới</li>
          <li className="tlt" />
        </ul>
      </div>
      <div id="sky-bg">
        <div className="clouds_one" />
        <div className="clouds_two" />
        <div className="clouds_three" />
      </div>
      <Header />

      <section>
        <div className="container contentContainer">
          <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
              <ul className="breadcrumbs">
                <li>
                  <a href="/"><span>Linh Quy Pháp Ấn</span></a>
                </li>
                <li><span>›</span></li>
                <li>
                  <a href="/contact"><span>Liên hệ</span></a>
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
              <iframe width="100%" height="300px" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3910.8512151974205!2d107.81987521532757!3d11.418343250137587!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31740f2d77f1c93f%3A0xa7ff9c6ebc40f1ff!2zQ2h1zIBhIExpbmggUXVpIFBoYcyBcCDGr8yBbmcsIEzhu5ljIFRow6BuaCwgQuG6o28gTMOibSwgTMOibSDEkOG7k25nLCBWaWV0bmFt!5e0!3m2!1sen!2s!4v1466987989809" /><br />
            </div>
          </div>
          <div className="row">
            <div id="contact-details" className="col-md-6 col-sm-12 col-xs-12 ">
              <h2>Thông tin liên hệ</h2>
              <ul>
                <li><i className="fa fa-map-marker" />
                  Thôn 4 xã Lộc Thành - Huyện Bảo Lâm - Tỉnh Lâm Đồng
                </li>
              </ul>
              <ul>
                <li><i className="fa fa-phone" /> 0963 232 651</li>
                <li><i className="fa fa-envelope-o" /> linhquyphapan@yahoo.com</li>
                <li><i className="fa fa-star" /> www.linhquyphapan.vn</li>
              </ul>
            </div>
            <div className="col-md-6 col-sm-12 col-xs-12  formcontact">
              <form action="/Contact" method="post"><input name="__RequestVerificationToken" type="hidden" defaultValue="u18uOigs9_iffhxqStgiV4DWzwqevJAqFWd7TPA3r7QvXEgfz4U0BZopoPtFC6qUCHaN6tecaRKBBQgqskL3-vYvrcI1" />            <div className="form-group">
                <input className="form-control" data-val="true" data-val-required="Vui lòng điền tên của bạn" id="Username" maxLength={142} minLength={2} name="Username" placeholder="* Điền tên của bạn" required="True" type="text" defaultValue />
                <p><span className="field-validation-valid" data-valmsg-for="Username" data-valmsg-replace="true" /></p>
              </div>
                <div className="form-group">
                  <input className="form-control" data-val="true" data-val-email="Vui lòng nhập email hợp lệ" data-val-required="Vui lòng nhập email" id="Email1" maxLength={142} minLength={5} name="Email1" placeholder="* Điền email của bạn" required="True" type="email" defaultValue />
                  <p><span className="field-validation-valid" data-valmsg-for="Email1" data-valmsg-replace="true" /></p>
                </div>
                <div className="form-group">
                  <input className="form-control" data-val="true" data-val-regex="Vui lòng điền số điện thoại hợp lệ" data-val-regex-pattern="^(\(([0-9]{2,3})\))?([0-9]{8,11})$" data-val-required="Vui lòng nhập số điện thoại" id="Phone" maxLength={50} minLength={5} name="Phone" placeholder="* Số điện thoại" required="True" type="tel" defaultValue />
                  <p><span className="field-validation-valid" data-valmsg-for="Phone" data-valmsg-replace="true" /></p>
                </div>
                <div className="form-group">
                  <input className="form-control" id="Address" maxLength={142} name="Address" placeholder="Địa chỉ" type="text" defaultValue />
                  <p><span className="field-validation-valid" data-valmsg-for="Address" data-valmsg-replace="true" /></p>
                </div>
                <div className="form-group">
                  <input className="form-control" data-val="true" data-val-required="Vui lòng điền tiêu đề" id="Subject" maxLength={142} minLength={5} name="Subject" placeholder="* Tiêu đề" required="True" type="text" defaultValue />
                  <p><span className="field-validation-valid" data-valmsg-for="Subject" data-valmsg-replace="true" /></p>
                </div>
                <div className="form-group">
                  <textarea className="form-control" cols={20} data-val="true" data-val-required="Vui lòng điền nội dung" id="Text" minLength={5} name="Text" placeholder="* Nội dung" required="True" rows={2} defaultValue={""} />
                  <p><span className="field-validation-valid" data-valmsg-for="Text" data-valmsg-replace="true" /></p>
                </div>
                <noscript>
                  &lt;iframe frameborder="0" height="300px" src="http://www.google.com/recaptcha/noscript?k=6LeL3f4SAAAAACV8soXq1bRm-FLgXj_FKukrOIUz" width="500px"&gt;&lt;/iframe&gt;
                  &lt;br /&gt;&lt;br /&gt;
                  &lt;textarea cols="40" name="recaptcha_challenge_field" rows="3"&gt;&lt;/textarea&gt;
                  &lt;input name="recaptcha_response_field" type="hidden" value="manual_challenge" /&gt;
                </noscript>
                <div id="contact-submit-button">
                  <div id="contact-submit-button">
                    <input type="submit" className="btn btn-warning" id="submit" defaultValue="Gửi" />
                  </div>
                </div>
              </form>   </div>
          </div>
          <div id="loading">
            <img src="/Content/loading.gif" />
          </div>
        </div>
      </section>

      <footer>
        <div className="container">
          <div className="_Slide3DContainer wow fadeInUp" data-wow-delay="0.4s">
            <ul className="carousel ">
              <li className="item active">
                <a href="/kinh-sach/cua-vao-bat-tu" className="itemSlide3d" tipcontent="CỬA VÀO BẤT TỬ"><img src={require("./Upload/images/z2345923129108_b9a2cd08e07aba3cab7e274c4c1896db.jpg")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/nghi-thuc-tu-hoc-nikaya" className="itemSlide3d"><img src={require("./Upload/images/Nghi Thức Tu Học NIKAYA(1).jpg")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/phap-hanh-nikaya-can-ban" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/tam-hy-ngot-ngao" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/tam-hien-van-an" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
      <section className="footer-copyright">
        <div className="container">
          <div className="row">
            <div className="col-md-1">
              <img className="img-responsive" src={require("./Theme/img/linhqquylogo-small.jpg")} />
            </div>
            <div className="col-md-5">
              Copyright © 2011 - 2024<br />Linhquyphapan.vn, All right reserved <br />Chủ nhiệm: Thượng Toạ Thích Minh Thành
            </div>
            <div className="col-md-6">
              Thôn 4 - Xã Lộc Thành - Huyện Bảo Lâm - Tỉnh Lâm Đồng <br />SĐT: 0963 232 651 , 0766 522 181<br />Email: linhquyphapan@yahoo.com <br /> www.linhquyphapan.vn
            </div>
          </div>
        </div>
      </section>
      <p id="back-top" style={{ display: 'none' }}>
        <a href="#top"><span /></a>
      </p>
      <div id="fb-root" />
    </div>
  );
}

export default ContactPage;
